import { useEffect } from "react";

const OSNOVNA_ADRESA = "https://okvirtus.hr";

function postavi(selektor, atribut, vrijednost) {
  const oznaka = document.head.querySelector(selektor);
  if (oznaka) oznaka.setAttribute(atribut, vrijednost);
}

/**
 * Stranica je SPA - sve rute posluzuje isti index.html, pa bi bez ovoga i
 * dvorane i galerija i obavijesti u Googleu imale naslov i opis pocetne, sto
 * ih izgleda kao jednu te istu stranicu. Google izvrsava JavaScript i cita
 * ono sto zatekne nakon renderiranja, tako da je dovoljno pri svakoj promjeni
 * rute osvjeziti oznake koje su vec u index.html-u.
 *
 * "putanja" je adresa kakvu zelimo u indeksu (canonical), ne nuzno ona u
 * pregledniku - pocetna se npr. vidi kao "/pocetna", a indeksira kao "/".
 */
export function useSEO({ naslov, opis, putanja }) {
  useEffect(() => {
    const adresa = `${OSNOVNA_ADRESA}${putanja}`;

    document.title = naslov;
    postavi('meta[name="description"]', "content", opis);
    postavi('meta[property="og:title"]', "content", naslov);
    postavi('meta[property="og:description"]', "content", opis);
    postavi('meta[property="og:url"]', "content", adresa);
    postavi('link[rel="canonical"]', "href", adresa);
  }, [naslov, opis, putanja]);
}
